/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, threshold: NonNullable<unknown> }} Vivid_Bronze_Yak_GrowInputs */

const en_vivid_bronze_yak_grow = /** @type {(inputs: Vivid_Bronze_Yak_GrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hidden (${i?.count}/${i?.threshold} responses)`)
};

const de_vivid_bronze_yak_grow = /** @type {(inputs: Vivid_Bronze_Yak_GrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verborgen (${i?.count}/${i?.threshold} Antworten)`)
};

/**
* | output |
* | --- |
* | "Hidden ({count}/{threshold} responses)" |
*
* @param {Vivid_Bronze_Yak_GrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vivid_bronze_yak_grow = /** @type {((inputs: Vivid_Bronze_Yak_GrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Bronze_Yak_GrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vivid_bronze_yak_grow(inputs)
	return de_vivid_bronze_yak_grow(inputs)
});